import { EnergyTypes } from './EnergyTableResult'
import React from 'react'
import { EnergyTableSingleCategoryColumn } from './EnergyTableSingleCategoryColumn'
import { EnergyTableDuoCategoryColumn } from './EnergyTableDuoCategoryColumn'

export type EnergyTableColumnData = {
  timestamp: string
  value: number
}

export type EnergyTableColumnCategory = {
  type: EnergyTypes
  max: number
  values: EnergyTableColumnData[]
}

export interface EnergyTableColumn {
  title: string
  link?: string
  imported?: EnergyTableColumnCategory
  exported?: EnergyTableColumnCategory
}

export const EnergyTableColumn = ({ title, link, imported, exported }: EnergyTableColumn) => {
  if (imported && !exported) {
    return <EnergyTableSingleCategoryColumn title={title} max={imported.max} values={imported.values} type={imported.type} link={link} />
  }

  if (exported && !imported) {
    return <EnergyTableSingleCategoryColumn title={title} max={exported.max} values={exported.values} type={exported.type} link={link} />
  }

  if (exported && imported) {
    return <EnergyTableDuoCategoryColumn title={title} imported={imported} exported={exported} link={link} />
  }

  return <></>
}
